import * as routes from '@/constants/routes';
import * as entityStatuses from '@/constants/entityStatuses';
import * as subjects from '@/constants/subjects';
import * as actions from '@/constants/actions';
import { canAbility } from './middleware';

export default {
  path: '/owner-calendar',
  name: routes.OWNER_CALENDAR,
  component: () => import('@/views/OwnerCalendar.vue'),
  meta: {
    middleware: [canAbility([actions.READ], subjects.OWNER_CALENDAR)],
  },
  props: route => ({ status: entityStatuses.ACTIVE, page: Number(route.query.page) || 1 }),
};
